import { useEffect, useState, useContext, useRef } from "react";
import L from "leaflet";
import { HOST, HOST_MEDIA_URL } from "../../host";
import { GlobalContext } from "../../../App";
import { Rnd } from "react-rnd";
import "./popupselect.css";
import "leaflet/dist/leaflet.css";
import AttributeQuery from "../../static/AttributeQuery";
import { ToastContainer, toast } from "react-toastify";
import eventEmitter from "../../eventEmitter";
import "bootstrap/dist/css/bootstrap.min.css";
import Symbology from "./Symbology";

const SelectByAttribute = () => {
  const {
    map,
    Canvas,
    layerControls,
    vis,
    isSidebarTabs,
    getCsrfToken,
    tools,
    vectors,
    setVectors,
    layerData,
    setLayerData,
    highlightedId,setHighlightedId,
    highlightedIdFeature, setHighlightedIdFeature
  } = useContext(GlobalContext);
  const [modalOpen, setModalOpen] = useState(false);
  const [show, setshow] = useState(false);
  const [modalUrl, setModalUrl] = useState("");
  const [modalSize, setModalSize] = useState({ width: 650, height: 500 });
  const [showTable, setShowTable] = useState(false);
  const [loiData, setLoiData] = useState([]);
  const [proposedData, setProposedData] = useState([]);
  const [showSelectPopup, setShowSelectPopup] = useState(false);
  const [selectedTable, setSelectedTable] = useState("");
  const [queryConditions, setQueryConditions] = useState([]);
  const [isEditable, setIsEditable] = useState(false);
  const [selectedLabelFields, setSelectedLabelFields] = useState([]);
  const [modalImages, setModalImages] = useState([]);
  const [showLabels, setShowLabels] = useState(false);
  const [geoJsonData, setGeoJsonData] = useState({
    type: "FeatureCollection",
    features: [],
  });
  const labelMarkersRef = useRef({});
  const [dataSource, setDataSource] = useState("LOI"); // or "Proposed"
  const toolRef = useRef(null);
  const [selLayer1, SetlLayer1] = useState(null);
  const [props, setProps] = useState([]);
  const [showAddInput, setShowAddInput] = useState(false);
  const [newColumnName, setNewColumnName] = useState("");
  const [showFieldCalculator, setShowFieldCalculator] = useState(false);
  const [manualQuery, setManualQuery] = useState("");
  const [result, setResult] = useState([]);
  const [selectedOperator, setSelectedOperator] = useState("+");
  const [targetColumn, setTargetColumn] = useState("");
  const [isMinimized, setIsMinimized] = useState(false);
  const [showdeleteSelection, setShowDeleteSelection] = useState(false);
  const geoJsonLayerRef = useRef(null);
  const highlightLayersMap = useRef(new Map());
  const [showSymbology, setShowSymbology] = useState(false);
  const [searchText, setSearchText] = useState("");


  const evaluateCondition = (row, condition) => {
    const { column, operator, value } = condition;
    let rowValue = row[column];

    const normalize = (val) => {
      // If the value is an empty string, treat it as null
      if (val === "") return null;

      // If the value is already an array, return it as is, otherwise wrap it in an array
      return Array.isArray(val) ? val : [val];
    };

    const normalizedRowValue = normalize(rowValue);
    const normalizedConditionValue = normalize(value);

    console.log(`Row Value: ${rowValue}`);
    console.log(`Condition Value: ${value}`);
    console.log(`Normalized row value: ${normalizedRowValue}`);
    console.log(`Normalized condition value: ${normalizedConditionValue}`);

    // Ensure both normalized values are just single values, not arrays
    const rowValueToCompare = normalizedRowValue ? normalizedRowValue[0] : null;
    const conditionValueToCompare = normalizedConditionValue
      ? normalizedConditionValue[0]
      : null;

    console.log(`Final row value to compare: ${rowValueToCompare}`);
    console.log(`Final condition value to compare: ${conditionValueToCompare}`);

    // Convert both values to numbers for comparison (if they can be numbers)
    const numRowValue = Number(rowValueToCompare);
    const numConditionValue = Number(conditionValueToCompare);

    console.log(`Converted row value: ${numRowValue}`);
    console.log(`Converted condition value: ${numConditionValue}`);

    switch (operator) {
      case "Equal to":
        // Handle both string and number comparisons
        return (
          numRowValue === numConditionValue ||
          String(rowValueToCompare) === String(conditionValueToCompare)
        );

      case "Not equal to":
        // Handle both string and number comparisons
        return (
          numRowValue !== numConditionValue &&
          String(rowValueToCompare) !== String(conditionValueToCompare)
        );

      case "Greater than":
        return numRowValue > numConditionValue;

      case "Greater than equal to":
        return numRowValue >= numConditionValue;

      case "Less than":
        return numRowValue < numConditionValue;

      case "Less than equal to":
        return numRowValue <= numConditionValue;

      case "is null":
        return rowValueToCompare === null;

      case "is not null":
        return rowValueToCompare !== null;

      default:
        console.warn(`Unknown operator: ${operator}`);
        return false;
    }
  };

  const shouldHighlightRow = (row) => {
    let matches = false;

    queryConditions.forEach((condition, index) => {
      const result = evaluateCondition(row, condition);
      console.log(
        `Condition ${index}: ${JSON.stringify(condition)} => Result: ${result}`
      );

      if (index === 0) {
        matches = result;
      } else {
        matches =
          condition.clause === "AND" ? matches && result : matches || result;
      }
    });

    console.log(`Row matches: ${matches}`);
    return matches;
  };

  // useEffect(() => {
  //     if (layerControls) {
  //         setVectors(Canvas.getLayers());
  //     }

  //     if (selectedTable) {
  //         setLayerData(Canvas.getLayerData(selectedTable));
  //     }

  //     SetlLayer1(null);
  // }, [show, selectedTable]);

  // useEffect(() => {
  //   if (layerControls) {
  //     setVectors(Canvas.getLayers());
  //   }

  //   if (selectedTable) {
  //     // Only set layerData if not already modified
  //     setLayerData((prev) => {
  //       if (!prev || prev.name !== selectedTable) {
  //         return Canvas.getLayerData(selectedTable);
  //       }

  //       return prev;
  //     });
  //   }

  //   SetlLayer1(null);
  // }, [show, selectedTable]);

  // useEffect(() => {
  //   if (layerControls) {
  //     setVectors(Canvas.getLayers());
  //   }

  //   if (selectedTable) {
  //     setLayerData((prev) => {
  //       if (!prev || prev.name !== selectedTable) {
  //         const layer = Canvas.getLayerData(selectedTable);

  //         const updatedFeatures = layer.features.map((feature, index) => {
  //           return {
  //             ...feature,
  //             properties: {
  //               fid: feature.properties?.fid ?? index + 1,
  //               ...feature.properties,
  //             },
  //           };
  //         });

  //         const updatedLayer = {
  //           ...layer,
  //           features: updatedFeatures,
  //         };

  //         //   Update the source Canvas layer so getProps will include `fid`
  //         Canvas.updateLayerData(selectedTable, updatedLayer);

  //         return updatedLayer;
  //       }

  //       return prev;
  //     });
  //   }

  //   SetlLayer1(null);
  // }, [show, selectedTable]);

  // useEffect(() => {
  //   if (tools) {
  //     console.log("Tools are enabled, setting up SelectByAttribute");
  //   }

  //   if (layerControls) {
  //     setVectors(Canvas.getLayers());
  //   }

  //   if (selectedTable) {
  //     setLayerData((prev) => {
  //       if (!prev || prev.name !== selectedTable) {
  //         const layer = Canvas.getLayerData(selectedTable);

  //         const updatedFeatures = layer.features.map((feature, index) => {
  //           return {
  //             ...feature,
  //             properties: {
  //               selection: false,
  //               fid: feature.properties?.fid ?? index + 1,
  //               ...feature.properties,
  //             },
  //           };
  //         });

  //         const updatedLayer = {
  //           ...layer,
  //           features: updatedFeatures,
  //         };

  //         //   Update the source Canvas layer so getProps will include `fid`
  //         Canvas.updateLayerData(selectedTable, updatedLayer);

  //         return updatedLayer;
  //       }

  //       return prev;
  //     });
  //   }

  //   SetlLayer1(null);
  // }, [show, selectedTable, tools]);

  useEffect(() => {
    if (tools) {
      console.log("Tools are enabled, setting up SelectByAttribute");
    }

    if (layerControls && Canvas?.getLayers) {
      setVectors(Canvas.getLayers());
    }

    if (!selectedTable || !Canvas?.getLayerData) {
      setLayerData(null);
      return;
    }

    try {
      const layer = Canvas.getLayerData(selectedTable);

      if (!layer || !Array.isArray(layer.features)) {
        console.warn("Invalid or missing layer data for:", selectedTable);
        setLayerData(null);
        return;
      }

      setLayerData((prev) => {
        if (!prev || prev.name !== selectedTable) {
          const updatedFeatures = layer.features.map((feature, index) => ({
            ...feature,
            properties: {
              selection: false,
              fid: feature.properties?.fid ?? index + 1,
              ...feature.properties,
            },
          }));

          const updatedLayer = {
            ...layer,
            features: updatedFeatures,
          };

          //   Update the source Canvas layer so getProps will include `fid`
          Canvas.updateLayerData(selectedTable, updatedLayer);

          return updatedLayer;
        }

        return prev;
      });
    } catch (err) {
      console.error("Error loading layer data:", err);
      setLayerData(null);
    }

    SetlLayer1(null);
  }, [show, selectedTable, Canvas, layerControls, tools]);

  useEffect(() => {
    if (selectedTable) {
      setProps(Canvas.getProps(selectedTable, false));
    }
  }, [selectedTable]);

  useEffect(() => {
    // Assuming 'geoJsonData', 'level', 'filename' are in scope or state
    if (layerData) {
      AddLayer(layerData);
    }
  }, [queryConditions]);


  useEffect(() => {
    if (!highlightedIdFeature?.features) return;
  
    // Collect fids from highlighted features
    const highlightedFids = new Set(
      highlightedIdFeature.features.map((hf) => hf.properties.fid)
    );
  
    setLayerData((prev) => {
      if (!prev) return prev;
  
      const updatedFeatures = prev.features.map((f) => {
        // ✅ Only set true for the new highlights
        if (highlightedFids.has(f.properties.fid)) {
          return {
            ...f,
            properties: {
              ...f.properties,
              selection: true,
            },
          };
        }
        return f; // leave others unchanged (user can deselect manually)
      });
  
      return { ...prev, features: updatedFeatures };
    });
  }, [showTable]);
  
  
//  useEffect(() => {
//     if (!map || selectedLabelFields.length === 0) return;

//     layerData.features.forEach((feature, index) => {
//       const layer = L.geoJSON(feature).getLayers()[0];
//       const featureProps = layer.feature?.properties || feature.properties;

//       selectedLabelFields.forEach((field) => {
//         console.log(`Feature ${index} - ${field}:`, featureProps[field]);
//       });

//       let labelText = selectedLabelFields
//         .map((field) => {
//           const value = featureProps[field] || "No data";
//           return value
//             ? `<div style="
//                     margin: 2px;
//                     padding: 2px 6px;
//                     background-color: white;
//                     color: black;
//                     border: 1px solid black;
//                     border-radius: 5px;
//                     font-weight: bold;
//                     white-space: nowrap;
//                     width:fit-content;
//                 ">${value}</div>`
//             : null;
//         })
//         .filter(Boolean)
//         .join("");

//       console.log("Generated labelText:", labelText);

//       let position;

//       if (typeof layer.getBounds === "function") {
//         const bounds = layer.getBounds();
//         if (!bounds.isValid()) {
//           console.log(`Invalid bounds for feature ${index}`);
//           return;
//         }
//         position = bounds.getCenter();
//       } else if (layer.getLatLng) {
//         position = layer.getLatLng();
//       } else {
//         console.warn("Cannot determine label position for feature", feature);
//         return;
//       }

//       const key = `${dataSource}-${index}`;

//       if (labelText) {
//         const label = L.divIcon({
//           className: "custom-label",
//           html: `<div style="display: flex; flex-direction: column;">${labelText}</div>`,
//           iconAnchor: [labelText.length * 3, 0],
//           // iconSize: [90, 40 + 20 * selectedLabelFields.length],
//           // iconAnchor: [45, 20],
//         });

//         const labelMarker = L.marker(position, { icon: label, interactive: false, }).addTo(map);

//         labelMarker.bindPopup(`<b>${dataSource} Label Popup</b>`);

//         if (!labelMarkersRef.current[key]) {
//           labelMarkersRef.current[key] = [];
//         }
//         labelMarkersRef.current[key].push({
//           feature,
//           marker: labelMarker,
//         });
//       } else {
//         if (labelMarkersRef.current[key]) {
//           labelMarkersRef.current[key].forEach(({ marker }) => {
//             map.removeLayer(marker);
//           });
//           labelMarkersRef.current[key] = [];
//         }
//       }
//     });

//     return () => {
//       Object.values(labelMarkersRef.current).forEach((markers) => {
//         markers.forEach(({ marker }) => map.removeLayer(marker));
//       });
//       labelMarkersRef.current = {};
//     };
//   }, [selectedLabelFields, map, dataSource]);
  

useEffect(() => {
  if (!map || selectedLabelFields.length === 0 || !layerData?.features) return;

  const MIN_LABEL_DISTANCE = 50; // pixels - minimum spacing between labels

  const clearLabels = () => {
    Object.values(labelMarkersRef.current).forEach((markers) => {
      markers.forEach(({ marker }) => map.removeLayer(marker));
    });
    labelMarkersRef.current = {};
  };

  const updateLabels = () => {
    clearLabels();

    const drawnPoints = []; // keep pixel coords of placed labels

    layerData.features.forEach((feature, index) => {
      const layer = L.geoJSON(feature).getLayers()[0];
      if (!layer) return;

      const featureProps = feature.properties || {};

      let labelText = selectedLabelFields
        .map((field) => {
          const value =
            featureProps[field] !== undefined && featureProps[field] !== null
              ? featureProps[field]
              : "No data";

          return `<div style="
              margin: 2px;
              padding: 2px 6px;
              background-color: white;
              color: black;
              border: 1px solid black;
              border-radius: 5px;
              font-weight: bold;
              white-space: nowrap;
              width: fit-content;
            ">${value}</div>`;
        })
        .join("");

      if (!labelText) return;

      // Calculate label position
      let position;
      if (layer.getBounds && layer.getBounds().isValid()) {
        position = layer.getBounds().getCenter();
      } else if (layer.getLatLng) {
        position = layer.getLatLng();
      } else return;

      // Convert to pixel space (for overlap detection)
      const pixel = map.latLngToLayerPoint(position);
      const tooClose = drawnPoints.some(
        (p) =>
          Math.sqrt((p.x - pixel.x) ** 2 + (p.y - pixel.y) ** 2) <
          MIN_LABEL_DISTANCE
      );

      // Skip label if too close
      if (tooClose) return;

      // Remember pixel position of this label
      drawnPoints.push(pixel);

      // Create label marker
      const labelIcon = L.divIcon({
        className: "custom-label",
        html: `<div style="display:flex;flex-direction:column;">${labelText}</div>`,
        iconAnchor: [0, 0],
      });

      const labelMarker = L.marker(position, {
        icon: labelIcon,
        interactive: false,
        pane: "markerPane",
      }).addTo(map);

      // Store reference
      const key = `${dataSource}-${index}`;
      if (!labelMarkersRef.current[key]) labelMarkersRef.current[key] = [];
      labelMarkersRef.current[key].push({ feature, marker: labelMarker });
    });
  };

  updateLabels();
  map.on("zoomend moveend", updateLabels);

  return () => {
    map.off("zoomend moveend", updateLabels);
    clearLabels();
  };
}, [selectedLabelFields, map, dataSource, layerData]);

function convertToBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  async function uploadFeatureImage(base64Image, feature, lat, lng) {
    console.log("Uploading image for feature:", feature);
    try {
      const csrfToken = await getCsrfToken();

      if (!feature || !feature.properties) {
        throw new Error("Invalid feature object: 'properties' missing");
      }
      console.log("Lat:", lat, "Lng:", lng);

      const response = await fetch(
        `${HOST}/upload-feature-image?lat=${lat}&lng=${lng}`,
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            "X-CSRFToken": csrfToken,
          },
          body: JSON.stringify({
            feature_image: base64Image,
            lat: lat,
            lng: lng,
          }),
        }
      );

      console.log("response:", response);

      if (!response.ok) {
        const errorData = await response.json();
        console.error("Error response from backend:", errorData);
        throw new Error(errorData.error || "Failed to upload image");
      }

      const result = await response.json();
      const filepath = result.filepath;
      console.log("Filepath:", filepath);
      const relativePath = filepath.split("/media/")[1];
      const imageUrl = `${HOST_MEDIA_URL}/media/${relativePath}`;
      console.log("Image URL:", imageUrl);

      setModalImages((prevImages) => {
        const updatedImages = [...new Set([...prevImages, imageUrl])];
        console.log("Updated images:", updatedImages);
        return updatedImages;
      });
      let existingImages = feature.properties.Image || [];
      if (!Array.isArray(existingImages)) {
        existingImages = [existingImages];
      }
      existingImages = existingImages.flat();

      // Append the new image URL
      existingImages.push(imageUrl);

      feature.properties.Image = [...new Set(existingImages)];
      console.log("Updated feature:", feature);
      await updateFeatureInGeoJsonData(feature);

     setLayerData((prev) => {
      // Step 1: Replace the matched feature
      const updatedFeatures = prev.features.map((f) => {
        const isMatch = f.properties.fid === feature.properties.fid;
        return isMatch ? feature : f;
      });

      // Step 2: Ensure all features have `Image` property (if not already)
      const normalizedFeatures = updatedFeatures.map((f) => {
        return {
          ...f,
          properties: {
            ...f.properties,
            Image: f.properties.Image ?? null, 
          },
        };
      });

      // Step 3: Create updated layer
      const updatedLayer = {
        ...prev,
        features: normalizedFeatures,
      };

      // Step 4: Update the Canvas layer
      Canvas.updateLayerData(selectedTable, updatedLayer);

      // Step 5: Refresh props so "Image" appears in checkboxes
      setProps(Canvas.getProps(selectedTable, false));

      return updatedLayer;
    });

      alert("Image uploaded successfully!");
    } catch (error) {
      console.error("Upload failed:", error);
      alert(error.message);
    }
  }

  async function updateFeatureInGeoJsonData(updatedFeature) {
    console.log("Updating feature in GeoJSON data:", updatedFeature);
    try {
      const csrfToken = await getCsrfToken();
      const cleanedFeature = {
        type: updatedFeature.type,
        id: updatedFeature.id,
        geometry: updatedFeature.geometry,
        geometry_name: updatedFeature.geometry_name,
        properties: { ...updatedFeature.properties },
      };
      const response = await fetch(`${HOST}/update-feature-saving`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "X-CSRFToken": csrfToken,
        },
        body: JSON.stringify({ feature: cleanedFeature }),
      });

      const result = await response.json();
      console.log("Update result:", result);
      if (!response.ok) {
        console.error("Update failed:", result);
        throw new Error(result.error || "Failed to update feature");
      }

      alert("Feature updated successfully!");
    } catch (err) {
      console.error("Error:", err);
      alert(err.message);
    }
  }

  function AddLayer(data) {
    // console.log("features data", data.features);
    const featureLayers = new Map();

    if (!data || !data.features || data.features.length === 0) return;

    // Remove existing highlight layer for this table
    if (highlightLayersMap.current.has(selectedTable)) {
      const existingLayer = highlightLayersMap.current.get(selectedTable);
      map.removeLayer(existingLayer);
      highlightLayersMap.current.delete(selectedTable);
    }

    // Add GeoJSON layer to map with dynamic styling
    const geoJsonLayer = L.geoJSON(data, {
      pointToLayer: (feature, latlng) => {
        const isHighlighted = shouldHighlightRow(feature.properties);
        if (feature.geometry.type === "Point") {
          return isHighlighted
            ? L.circleMarker(latlng, {
                radius: 2,
                color: "yellow",
                fillOpacity: 0.8,
              })
            : L.circleMarker(latlng, {
                radius: 0,
                opacity: 0,
                fillOpacity: 0,
              }); 
        }
        return L.marker(latlng); 
      },

      // pointToLayer: (feature, latlng) => {
      //   const isHighlighted = shouldHighlightRow(feature.properties);

      //   // Use L.marker only if the feature should be highlighted
      //   if (feature.geometry.type === "Point") {
      //     if (isHighlighted) {
      //       const marker = L.marker(latlng); // <- use marker
      //       feature._highlightMarker = marker; // store marker for later removal
      //       return marker;
      //     } else {
      //       // Optional: return invisible marker to retain popup logic
      //       return L.marker(latlng, {
      //         opacity: 0,
      //         interactive: false,
      //       });
      //     }
      //   }

      //   return null; 
      // },
      
      style: (feature) => {
        const isHighlighted = shouldHighlightRow(feature.properties);

        return {
          color: isHighlighted ? "yellow" : "",
          opacity: isHighlighted ? 0.7 : 0,
          fillColor: "transparent",
          fillOpacity: 0,
        };
      },
      coordsToLatLng: function (coords) {
        return new L.LatLng(coords[1], coords[0]);
      },
      onEachFeature: function (feature, layer) {
        featureLayers.set(
          feature.properties.Latitude + "_" + feature.properties.Longitude,
          layer
        );

        console.log("Feature properties:", feature.properties);

        // if (feature.properties) {
        //   const allowedFields = ["CCTV", "Image", "Google_Map", "Drive_Link"];

        //   let buttonsHTML = `
        //                     <div class="popup-container">
        //                         <input type="file" id="popup-image-upload-${
        //                           feature.properties.Latitude
        //                         }_${feature.properties.Longitude}"
        //                           accept="image/*" style="display: none;" />
        //                         <button class="popup-button-btn" data-lat="${
        //                           feature.properties.Latitude
        //                         }" data-lng="${feature.properties.Longitude}"
        //                         style="
        //                           position: absolute;
        //                           top: 5px;
        //                           right: 35px;
        //                           padding: 4px 8px;
        //                           background: #004ab9;
        //                           border: none;
        //                           color: #FFFFFF;
        //                           cursor: pointer;
        //                           border-radius: 5px;
        //                           font: 14px Tahoma, Verdana, sans-serif;
        //                           height: 24px;
        //                         "
        //                         title="Upload Image"
        //                         >
        //                         <i class="fa-solid fa-upload"></i>

        //                         ${allowedFields
        //                           .map((key) => {
        //                             const value = feature.properties[key];
        //                             let buttonText = key;

        //                             if (key !== "Image" && !value) return null;
        //                             console.log(`Key: ${key}, Value: ${value}`);
        //                             if (key === "CCTV") buttonText = "CCTV";
        //                             else if (key === "Google_Map")
        //                               buttonText = "Google Map";
        //                             else if (key === "Drive_Link")
        //                               buttonText = "Document";

        //                             if (key === "Image" || key === "Image" || key === "image") {
        //                               return `<button class="popup-button image-popup" data-lat="${feature.properties.Latitude}"
        //                               data-lng="${feature.properties.Longitude}">
        //                               View Image
        //                               </button>`;
        //                             }
        //                             if (
        //                               typeof value === "string" &&
        //                               value.startsWith("http")
        //                             ) {
        //                               return `<button class="popup-button link-popup" data-url="${value}">${buttonText}</button>`;
        //                             }

        //                             return null;
        //                           })
        //                           .filter(Boolean)
        //                           .join("")}

        //                     </div>
        //                 `;

        //   layer.bindPopup(buttonsHTML || "<b>No relevant data available</b>");
        // }

       if (feature.properties) {
        layer.bindPopup(generatePopupHTML(feature));
      }

      },
    });

    geoJsonLayer.addTo(map);
    highlightLayersMap.current.set(selectedTable, geoJsonLayer);
    map.flyToBounds(geoJsonLayer.getBounds());

    map.off("popupopen");

   map.on("popupopen", (e) => {
   const popupContent = e.popup.getElement();

  if (!popupContent) return;

  popupContent.querySelectorAll(".popup-button-btn").forEach((uploadBtn) => {
    const lat = uploadBtn.getAttribute("data-lat");
    const lng = uploadBtn.getAttribute("data-lng");

    // const inputId = `popup-image-upload-${lat}_${lng}`;
    const sanitize = (str) => String(str).replaceAll(".", "_");
    const inputId = `popup-image-upload-${sanitize(lat)}_${sanitize(lng)}`;

    const fileInput = document.getElementById(inputId); 

    if (!fileInput) {
      console.error("File input not found:", inputId);
      return;
    }

    // Ensure this only binds once
    uploadBtn.addEventListener("click", () => {
      fileInput.click();
    });

    // Listen for change event
    fileInput.onchange = async (e) => {
      const file = e.target.files[0];
      if (!file) return;

      const base64Image = await convertToBase64(file);
      const featureLayer = featureLayers.get(`${lat}_${lng}`);

      if (!featureLayer || !featureLayer.feature) return;

      await uploadFeatureImage(base64Image, featureLayer.feature, lat, lng);

      //   Refresh popup with updated content
      const updatedHtml = generatePopupHTML(featureLayer.feature);
      featureLayer.bindPopup(updatedHtml).openPopup();

    };


  });
});

  }

  function generatePopupHTML(feature) {
    const { properties } = feature;
    const sanitize = (str) => String(str).replaceAll(".", "_");
    const inputId = `popup-image-upload-${sanitize(properties.Latitude)}_${sanitize(properties.Longitude)}`;
    const carouselId = `carousel-${inputId}`;
  
    let html = `<div class="popup-container" style="max-width: 300px;">`;
  
    // Key-value rows
    for (const key in properties) {
      if (key !== "Image") {
        html += `
          <div style="display: block; width: 100%; margin-bottom: 4px;">
            <strong>${key}:</strong> ${properties[key]}
          </div>
        `;
      }
    }
  
    // Image section
    const images = Array.isArray(properties.Image)
      ? properties.Image
      : properties.Image
      ? [properties.Image]
      : [];
  
    if (images.length > 0) {
      html += `
        <div style="margin-top: 8px; display:flex; flex-direction: row;">
          <strong>Image:</strong>
          <div id="${carouselId}" class="carousel slide mt-1" data-bs-ride="carousel">
            <div class="carousel-inner">
              ${images
                .map(
                  (url, idx) => `
                    <div class="carousel-item ${idx === 0 ? "active" : ""}">
                      <img src="${url}" class="d-block w-100" style="max-height: 200px;" />
                    </div>
                  `
                )
                .join("")}
            </div>
            <button class="carousel-control-prev" type="button" data-bs-target="#${carouselId}" data-bs-slide="prev">
              <span class="carousel-control-prev-icon"></span>
            </button>
            <button class="carousel-control-next" type="button" data-bs-target="#${carouselId}" data-bs-slide="next">
              <span class="carousel-control-next-icon"></span>
            </button>
          </div>
        </div>`;
    } else {
      html += `
        <div style="margin-top: 8px;">
          <strong>Image:</strong> <em>No images yet.</em>
        </div>`;
    }
  
    // Upload UI
    html += `
      <input type="file" id="${inputId}" accept="image/*" style="display: none;" />
      <button class="popup-button-btn btn btn-primary btn-sm mt-2" data-lat="${properties.Latitude}" data-lng="${properties.Longitude}">
        Upload Image
      </button>
    </div>`;
  
    return html;
  }
  
  const openModal = (url) => {
    setModalUrl(url); // iframe
    setModalImages([]); // clear images
    setModalOpen(true);
  };

  const openImageModal = (urls) => {
    setModalImages(urls); // image array
    setModalUrl(""); // clear iframe
    setModalOpen(true);
  };
  const closeModal = () => {
    setModalOpen(false);
    setModalUrl("");
  };

  const openSelectPopup = (tableType) => {
    setSelectedTable(tableType);
    setShowSelectPopup(true);
  };

  //     const updatedData = selectedTable === "LOI" ? [...loiData] : [...proposedData];
  //     const featureIndex = updatedData.findIndex(f => f.id === feature.id);
  //     if (featureIndex !== -1) {
  //         updatedData[featureIndex].properties[key] = e.target.textContent;
  //     }

  //     if (selectedTable === "LOI") {
  //         setLoiData(updatedData);
  //     } else if (selectedTable === "Proposed") {
  //         setProposedData(updatedData);
  //     }
  // };

  const handleEditChange = (e, featureIndex, key) => {
    const newValue = e.target.textContent;

    setLayerData((prevLayerData) => {
      if (
        !prevLayerData ||
        !prevLayerData.features ||
        !prevLayerData.features[featureIndex]
      ) {
        console.error("Feature is undefined at index:", featureIndex);
        return prevLayerData;
      }

      const updatedFeatures = [...prevLayerData.features];
      updatedFeatures[featureIndex] = {
        ...updatedFeatures[featureIndex],
        properties: {
          ...updatedFeatures[featureIndex].properties,
          [key]: newValue,
        },
      };

      return {
        ...prevLayerData,
        features: updatedFeatures,
      };
    });
  };
  //     await new Promise((resolve) => setTimeout(resolve, 100));

  //     const updatedData = selectedTable === layerData.features;

  //     const geoJsonStructure = {
  //         type: "FeatureCollection",
  //         name: selectedTable,
  //         crs: {
  //             type: "name",
  //             properties: {
  //                 name: "EPSG:4326",
  //             },
  //         },
  //         features: updatedData,
  //     };

  //     console.log("Sending updated GeoJSON:", geoJsonStructure);

  //     try {
  //         const response = await fetch(`${HOST}/save-geojson`, {
  //             method: "POST",
  //             headers: {
  //                 "Content-Type": "application/json",
  //                 "X-CSRFToken": await getCsrfToken(),
  //             },
  //             body: JSON.stringify({
  //                 dataset_type: selectedTable,
  //                 data: geoJsonStructure,
  //             }),
  //         });

  //         const result = await response.json();
  //         console.log("Save result:", result);

  //         if (response.ok) {
  //             alert("File saved successfully!");
  //             setIsEditable(false);
  //         } else {
  //             alert(`Error: ${result.error || "Something went wrong"}`);
  //         }
  //     } catch (error) {
  //         alert(`Error: ${error.message}`);
  //     }
  // };

  // const handleFieldChange = (key) => {
  //     setSelectedLabelFields((prev) => {
  //         if (prev.includes(key)) {
  //             return prev.filter((field) => field !== key);
  //         } else {
  //             return [...prev, key];
  //         }
  //     });
  // };

  const handleSave = async () => {
    try {
      // No need to wait anymore
      console.log("Saving edited values to Canvas...");

      const updatedGeoJson = {
        type: "FeatureCollection",
        name: selectedTable,
        crs: {
          type: "name",
          properties: {
            name: "EPSG:4326",
          },
        },
        features: layerData.features,
      };

      // ⬇ Update Canvas layer directly
      Canvas.updateLayerData(selectedTable, updatedGeoJson);

      console.log("Canvas layer updated after edit/save!");
      setIsEditable(false);
      alert("Changes saved locally!");
    } catch (error) {
      console.error("Error while saving:", error);
      alert(`Error: ${error.message}`);
    }
  };

  const handleFieldChange = (field) => {
    // Log the current state before updating
    console.log("Before updating, selectedLabelFields:", selectedLabelFields);

    if (selectedLabelFields.includes(field)) {
      // Remove the field if it's already selected
      const updatedFields = selectedLabelFields.filter((f) => f !== field);
      console.log(
        `Removed field: ${field}. Updated selectedLabelFields:`,
        updatedFields
      );
      setSelectedLabelFields(updatedFields);
    } else {
      // Add the field to the selected list
      const updatedFields = [...selectedLabelFields, field];
      console.log(
        `Added field: ${field}. Updated selectedLabelFields:`,
        updatedFields
      );
      setSelectedLabelFields(updatedFields);
    }
  };

  // const updateCanvasLayerProperties = (fieldName, defaultValue = "") => {
  //   const updatedLayer = Canvas.getLayerData(selectedTable);

  //   if (!updatedLayer) return;

  //   updatedLayer.features = updatedLayer.features.map((feature) => ({
  //     ...feature,
  //     properties: {
  //       ...feature.properties,
  //       [fieldName]: defaultValue,
  //     },
  //   }));

  //   // Now update inside Canvas
  //   Canvas.updateLayerData(selectedTable, updatedLayer);
  // };

  const updateCanvasLayerProperties = (fieldName, valuesArray = []) => {
    const updatedLayer = Canvas.getLayerData(selectedTable);
    if (!updatedLayer) return;

    if (
      !Array.isArray(valuesArray) ||
      valuesArray.length !== updatedLayer.features.length
    ) {
      console.error(
        "Values array length must match number of features in canvas layer."
      );
      return;
    }

    updatedLayer.features = updatedLayer.features.map((feature, index) => ({
      ...feature,
      properties: {
        ...feature.properties,
        [fieldName]: valuesArray[index] ?? "", // Assign computed value per feature
      },
    }));

    Canvas.updateLayerData(selectedTable, updatedLayer);
  };

  const handleAddColumn = () => {
    if (!newColumnName.trim()) {
      alert("Column name cannot be empty.");
      return;
    }

    const updatedFeatures = layerData.features.map((feature) => {
      return {
        ...feature,
        properties: {
          ...feature.properties,
          [newColumnName]: "", // Default value
        },
      };
    });

    setLayerData((prevLayerData) => ({
      ...prevLayerData,
      features: updatedFeatures,
    }));

    // ⬇ Update Canvas Layer as well
    updateCanvasLayerProperties(newColumnName, "");

    // Clear input after adding
    setNewColumnName("");
    setShowAddInput(false);
  };

  const calculateField = () => {
    try {
      if (!manualQuery || !targetColumn) {
        alert("Please build a query and select a target column.");
        return;
      }

      const newFeatures = layerData.features.map((feature) => {
        const expression = manualQuery.replace(
          /\b[A-Za-z_][A-Za-z0-9_]*\b/g,
          (match) => {
            const val = feature.properties[match];
            console.log('typeof value',typeof val, "val:", val);
            if (val === undefined) return match;
            return typeof val === "string" ? `"${val}"` : val;
          }
        );

        let computed;
        try {
          computed = eval(expression);
        } catch {
          computed = "Error";
        }

        return {
          ...feature,
          properties: {
            ...feature.properties,
            [targetColumn]: computed,
          },
        };
      });

      const resultValues = newFeatures.map((f) => f.properties[targetColumn]);
      setResult(resultValues);
      setLayerData((prev) => ({
        ...prev,
        features: newFeatures,
      }));

      // Update Canvas as well with new per-feature values
      updateCanvasLayerProperties(targetColumn, resultValues);
      alert(`Field "${targetColumn}" calculated successfully!`);
    } catch {
      alert("Please build a query and select a target column.");
    }
  };

  const handleDeleteColumn = (columnName) => {
    try {
      if (!columnName) return;

      const updatedFeatures = layerData.features.map((feature) => {
        const updatedProperties = { ...feature.properties };
        delete updatedProperties[columnName];

        return {
          ...feature,
          properties: updatedProperties,
        };
      });

      const updatedLayer = {
        ...layerData,
        features: updatedFeatures,
      };

      setLayerData(updatedLayer);
      Canvas.updateLayerData(selectedTable, updatedLayer);
     alert(`Column "${columnName}" deleted successfully!`);

    } catch (error) {
      console.error("Error deleting column:", error);
      alert(`An error occurred while deleting the column: ${error.message}`);
    }
  };

  const handleDeleteRow = (rowIndex) => {
    try {
      const confirmed = window.confirm(
        "Are you sure you want to delete this feature? This action cannot be undone."
      );
      if (!confirmed) return;

      const featureToRemove = layerData.features[rowIndex];

      if (geoJsonLayerRef.current) {
        geoJsonLayerRef.current.eachLayer((layer) => {
          if (
            layer.feature &&
            JSON.stringify(layer.feature.properties) ===
              JSON.stringify(featureToRemove.properties)
          ) {
            geoJsonLayerRef.current.removeLayer(layer);
          }
        });
      }

      const updatedFeatures = [...layerData.features];
      updatedFeatures.splice(rowIndex, 1);

      const updatedLayer = {
        ...layerData,
        features: updatedFeatures,
      };

      setLayerData(updatedLayer);
      Canvas.updateLayerData(selectedTable, updatedLayer);

      alert(`Feature removed successfully!`);
    } catch (error) {
      console.error("Error deleting row:", error);
      alert(`An error occurred while deleting the feature: ${error.message}`);
    }
  };

  const handleCheckboxToggle = (rowIndex) => {
    try {
      console.log("features:", layerData.features);
      setLayerData((prevData) => {
        const updatedFeatures = [...prevData.features];
        const currentFeature = updatedFeatures[rowIndex];

        const isSelected = !currentFeature.properties.selection;
        currentFeature.properties.selection = isSelected;

        const updatedLayer = {
          ...prevData,
          features: updatedFeatures,
        };

        Canvas.updateLayerData(prevData.name, updatedLayer);

        if (isSelected) {
          highlightFeatureOnMap(currentFeature);
        } else {
          unhighlightFeatureOnMap(currentFeature);
        }

        return updatedLayer;
      });
    } catch (error) {
      console.error("Error toggling selection:", error);
      alert(`An error occurred while toggling selection: ${error.message}`);
    }
  };

  const highlightFeatureOnMap = (feature) => {
    try {
      const layer = L.geoJSON(feature, {
        style: { color: "yellow", weight: 4 },
      }).addTo(map);

      feature._highlightLayer = layer;

      const bounds = layer.getBounds();
      if (bounds.isValid()) {
        map.flyToBounds(bounds, { maxZoom: 16 });
      }
    } catch (error) {
      console.error("Error highlighting feature:", error);
      alert(
        `An error occurred while highlighting the feature: ${error.message}`
      );
    }
  };

  const unhighlightFeatureOnMap = (feature) => {
    try {
      if (feature._highlightLayer) {
        map.removeLayer(feature._highlightLayer);
        delete feature._highlightLayer;
      }
    } catch (error) {
      console.error("Error unhighlighting feature:", error);
      alert(
        `An error occurred while unhighlighting the feature: ${error.message}`
      );
    }
  };

  return (
    <>
      <div
        style={{ position: vis ? "absolute" : "relative" }}
        className="toolscont"
      >
        <div>
          <button
            className="btn text-white"
            title="Select By Attribute"
            onClick={() => setshow(!show)}
            style={{
              backgroundColor: "black",
              width: "40px",
              height: "40px",
              borderRadius: "50%",
            }}
          >
            <i className="fa-solid fa-object-group"></i>
          </button>
        </div>

        {show && (
         <div ref={toolRef} className="toolsvis" id="toolvis"
  style={{ display: "flex", flexDirection: "column", width: "260px", padding: "10px 12px" }}
>
  {/* Header */}
  <div style={{
    display: "flex", justifyContent: "space-between", alignItems: "center",
    paddingBottom: "8px", marginBottom: "10px",
    borderBottom: "1px solid rgba(255,255,255,0.12)"
  }}>
    <span style={{ color: "#ccc", fontSize: "13px", fontWeight: 600 }}>
      <i className="fa-solid fa-object-group" style={{ marginRight: "6px", fontSize: "11px" }} />
      Select by attribute
    </span>
    <span
      onClick={() => setshow(false)}
      style={{ color: "#e74c3c", fontSize: "20px", cursor: "pointer", lineHeight: 1 }}
    >
      &times;
    </span>
  </div>

  {/* Inputs */}
  <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>

    {/* Layer select */}
    <div>
      <label style={{ fontSize: "11px", color: "#aaa", marginBottom: "3px", display: "block" }}>
        Select layer
      </label>
      <select
        className="form-select text-white"
        style={{
          fontSize: "12px", padding: "4px 6px",
          backgroundColor: "black",
          border: "1px solid rgba(255,255,255,0.25)",
          color: "white", borderRadius: "4px",
        }}
        value={selectedTable}
        onChange={(e) => {
          setSelectedTable(e.target.value);
          if (!e.target.value) setShowTable(false);
        }}
      >
        <option value="">— choose a layer —</option>
        {vectors.map((comp) => (
          <option key={comp} value={comp}>{comp}</option>
        ))}
      </select>
    </div>

    {/* Show Table */}
    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
      <input type="checkbox" id="chk-table" checked={showTable}
        onChange={(e) => {
          if (e.target.checked && selectedTable) setShowTable(true);
          else { alert("Please select a layer first."); setShowTable(false); }
        }}
      />
      <label htmlFor="chk-table" style={{ fontSize: "12px", color: "#ccc", cursor: "pointer" }}>
        Show table
      </label>
    </div>

    {/* Show Labels */}
    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
      <input type="checkbox" id="chk-labels" checked={showLabels}
        onChange={() => {
          if (showLabels) { setSelectedLabelFields([]); }
          setShowLabels(!showLabels);
        }}
      />
      <label htmlFor="chk-labels" style={{ fontSize: "12px", color: "#ccc", cursor: "pointer" }}>
        Show labels
      </label>
    </div>

    {/* Label field checkboxes */}
    {showLabels && selectedTable && props?.length > 0 && (
      <div style={{ paddingLeft: "4px", display: "flex", flexDirection: "column", gap: "4px" }}>
        <p style={{ fontSize: "11px", color: "#888", textTransform: "uppercase",
          letterSpacing: "0.04em", margin: "4px 0 2px" }}>Label fields</p>
        {props
          .filter((p) => !["selection", "_parentLayer"].includes(p))
          .map((comp) => (
            <div key={comp} style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <input type="checkbox" id={`prop-${comp}`}
                checked={selectedLabelFields.includes(comp)}
                onChange={() => handleFieldChange(comp)}
              />
              <label htmlFor={`prop-${comp}`}
                style={{ fontSize: "12px", color: "#bbb", cursor: "pointer" }}>
                {comp}
              </label>
            </div>
          ))}
      </div>
    )}

  </div>
</div>
        )}
      </div>

      {showTable && (
        <div className="modal-overlay" style={{ zIndex: 1000 }}>
          <Rnd
            style={{
              width: "100%",
              height: "100%",
              zIndex: 1000,
              left: tools ? "60px" : "360px",
              backgroundColor: "white",
            }}
            size={isMinimized ? { width: 350, height: 250 } : modalSize}
            default={{
              x: tools ? 0 : 400,
              y: 0,
              width: 950,
              height: 650,
            }}
            minWidth={350}
            minHeight={250}
            maxWidth={1900}
            maxHeight={950}
            disableDragging={false}
            bounds="window"
            enableResizing={!isMinimized}
            onResizeStop={(e, direction, ref, delta, position) => {
              if (!isMinimized) {
                setModalSize({
                  width: ref.offsetWidth,
                  height: ref.offsetHeight,
                });
              }
            }}
            // enableResizing={{
            //   bottomRight: true,
            //   bottomLeft: true,
            //   topRight: true,
            //   topLeft: true,
            //   left: true,
            //   right: true,
            //   top: true,
            //   bottom: true,
            // }}
          >
            <div
              className="modal-content"
              style={{ overflow: "scroll", pointerEvents: "auto" }}
            >
              <div
                className="user-modal-header"
                style={{ display: "flex", gap: "10px" }}
              >
                {isMinimized ? (
                  <i
                    className="fa-solid fa-up-right-and-down-left-from-center cancel"
                    title="Maximize"
                    style={{
                      cursor: "pointer",
                      margin: "0px",
                      marginBottom: "10px",
                      padding: "2px 8px 2px 2px", 
                    }}
                    onClick={() => setIsMinimized(false)}
                  ></i>
                ) : (
                  <i
                    className="fa-solid fa-window-minimize cancel"
                    title="Minimize"
                    style={{
                      cursor: "pointer",
                      margin: "0px",
                      marginBottom: "10px",
                      fontSize: "10px",
                      fontWeight: "bolder",
                      padding: "2px 12px 2px 3px" 
                    }}
                    onClick={() => setIsMinimized(true)}
                  ></i>
                )}

                <i
                  className="fa-solid fa-xmark cancel"
                  style={{ margin: "0px", marginBottom: "10px" }}
                  onClick={() => {
                    setShowTable(false);
                    setIsMinimized(false);
                  }}
                ></i>
              </div>

              {selectedTable && layerData?.features?.length > 0 && (
                console.log("Rendering table for:", selectedTable, layerData),
                <>
                 <h5>{selectedTable} Data</h5>
                  <div className="table-head-options">
                    <button
                      className="select-attributes"
                      onClick={() => {
                        if (isEditable) {
                          handleSave();
                        } else {
                          setIsEditable(true);
                        }
                      }}
                    >
                      {isEditable ? "Save Field" : "Edit Field"}
                    </button>

                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >

                      {showAddInput && (
                        <>
                          <input
                            type="text"
                            value={newColumnName}
                            onChange={(e) => setNewColumnName(e.target.value)}
                            placeholder="New Column Name"
                            className="form-control"
                            style={{ width: "200px", fontSize: "13px" }}
                          />
                          <button
                            className="select-attributes"
                            onClick={handleAddColumn}
                          >
                            Submit
                          </button>
                        </>
                      )}

                      <button
                        className="select-attributes"
                        style={{ backgroundColor: showAddInput ? "#dc3545" : "" }}
                        onClick={() => setShowAddInput(!showAddInput)}
                      >
                        {showAddInput ? "Cancel" : "Add Column"}
                      </button>

                        {showdeleteSelection && (
                      <>
                        <select
                          className="form-select"
                          style={{
                            width: "200px",
                            fontSize: "13px",
                            display: "inline-block",
                            marginRight: "8px",
                          }}
                          onChange={(e) => setTargetColumn(e.target.value)}
                          value={targetColumn}
                        >
                          <option value="">Select column to delete</option>
                          {Object.keys(layerData.features[0].properties)
                          .filter((key) => !["selection","_parentLayer", "_layerColor"].includes(key))
                          .map(
                            (key, idx) => (
                              <option key={idx} value={key}>
                                {key}
                              </option>
                            )
                          )}
                        </select>

                        <button
                          className="select-attributes bg-danger"
                          onClick={() => {
                            if (targetColumn) {
                              if (
                                window.confirm(
                                  `Are you sure you want to delete "${targetColumn}"?`
                                )
                              ) {
                                handleDeleteColumn(targetColumn);
                                setTargetColumn(""); 
                                setShowDeleteSelection(false); 
                              }
                            } else {
                              alert("Please select a column to delete.");
                            }
                          }}
                        >
                          Delete Column
                        </button>
                      </>
                    )}
                      <button
                        className="select-attributes"
                        onClick={() => setShowDeleteSelection(!showdeleteSelection)}
                      >
                       {showdeleteSelection ? "Cancel" : "Delete Column"} 
                      </button>

                      <button
                        className="select-attributes"
                        onClick={() => setShowFieldCalculator(true)}
                      >
                        Field Calculator
                      </button>

                      
                    </div>

                    <button
                      className="select-attributes"
                      onClick={(e) => {
                        e.stopPropagation();
                        openSelectPopup(selectedTable);
                      }}
                    >
                      Select by Attribute
                    </button>

                    <button
                      className="select-attributes"
                      onClick={(e) => {
                        e.stopPropagation();
                        setQueryConditions([]);
                        // Remove highlight layer for the current selectedTable
                        if (highlightLayersMap.current.has(selectedTable)) {
                          const highlightLayer =
                            highlightLayersMap.current.get(selectedTable);
                          map.removeLayer(highlightLayer);
                          highlightLayersMap.current.delete(selectedTable);
                        }
                        Canvas.deHighlightLayer(highlightedId);
  
                        // Reset state
                        setHighlightedId(null);
                        setHighlightedIdFeature(null);
                      
                        // Also reset selection flags in attribute table
                        setLayerData((prev) => {
                          if (!prev) return prev;
                          const cleared = {
                            ...prev,
                            features: prev.features.map((f) => ({
                              ...f,
                              properties: { 
                                ...f.properties,
                                selection: false,   // clear highlight
                              },
                            })),
                          };
                          if (prev.name) {
                            Canvas.updateLayerData(prev.name, cleared);
                          }
                          return cleared;
                        });
                      }}
                    >
                      Remove Highlights
                    </button>

                    <button
                      className="select-attributes"
                      onClick={(e) => {
                        e.stopPropagation();
                        setQueryConditions((prev) => {
                          if (layerData.features.length === 0) return [];

                          const highlightedRows = layerData.features.filter(
                            (feature) => shouldHighlightRow(feature.properties)
                          );
                          const unhighlightedRows = layerData.features.filter(
                            (feature) => !shouldHighlightRow(feature.properties)
                          );

                          if (highlightedRows.length === 0) {
                            return layerData.features.map((feature) => ({
                              column: Object.keys(feature.properties)[0],
                              operator: "Equal to",
                              value:
                                feature.properties[
                                  Object.keys(feature.properties)[0]
                                ],
                            }));
                          }

                          return unhighlightedRows.map((feature) => ({
                            column: Object.keys(feature.properties)[0],
                            operator: "Equal to",
                            value:
                              feature.properties[
                                Object.keys(feature.properties)[0]
                              ],
                          }));
                        });
                      }}
                    >
                      Inverse Highlight
                    </button>

                    <button
                    className="select-attributes"
                    onClick={() => {
                      try {
                        if (!layerData || !map || !layerControls) {
                          alert("Map or LayerControl not found.");
                          return;
                        }

                        // Filter highlighted features
                        // Collect both highlighted and manually selected features
                      const exportableFeatures = layerData.features.filter(
                        (feature) =>
                          shouldHighlightRow(feature.properties) || feature.properties.selection
                      );

                      if (exportableFeatures.length === 0) {
                        alert("No highlighted or selected features to export.");
                        return;
                      }

                        const exportLayerName = `${selectedTable}_${Date.now()}`;
                        // Clean out Leaflet internal references before export
                        const cleanedFeatures = exportableFeatures.map(f => {
                          const { _highlightLayer, ...rest } = f;   // remove non-GeoJSON refs
                          return {
                            ...rest,
                            properties: { ...rest.properties },      // shallow clone properties
                          };
                        });

                        //creating gejson layer to export
                        const exportGeoJSON = {
                          type: "FeatureCollection",
                          features: cleanedFeatures,
                        };

                        // Create a new Leaflet GeoJSON layer
                        const newLayer = L.geoJSON(exportGeoJSON, {

                          onEachFeature: (feature, layer) => {
                            let popupHtml = Object.entries(feature.properties)
                              .map(([k, v]) => `<b>${k}</b>: ${v}`)
                              .join("<br>");
                            layer.bindPopup(popupHtml);
                          },
                        })

                        const newExportLayer = newLayer.toGeoJSON();
                        console.log("New Layer to Export:", newExportLayer);

                        Canvas.deHighlightLayer(highlightedId);
                        setHighlightedIdFeature(null);
                        setHighlightedId(null);
                        
                        // 🔹 Remove highlight layers created via highlightFeatureOnMap()
                          if (layerData?.features) {
                            layerData.features.forEach((feature) => {
                              if (feature._highlightLayer) {
                                try {
                                  map.removeLayer(feature._highlightLayer);
                                  delete feature._highlightLayer;
                                } catch (err) {
                                  console.warn("Error removing individual highlight layer:", err);
                                }
                              }
                            });
                          }

                          // Remove overall highlight visualization layer (yellow highlight layer)
                          if (highlightLayersMap.current.has(selectedTable)) {
                            const existingHighlightLayer = highlightLayersMap.current.get(selectedTable);
                            map.removeLayer(existingHighlightLayer);
                            highlightLayersMap.current.delete(selectedTable);
                          }

                        //  Clear selection flags
                        setLayerData((prev) => {
                          if (!prev) return prev;
                          const cleared = {
                            ...prev,
                            features: prev.features.map((f) => ({
                              ...f,
                              properties: { 
                                ...f.properties,
                                selection: false,
                              },
                            })),
                          };
                          if (prev.name) {
                            Canvas.updateLayerData(prev.name, cleared);
                          }
                          return cleared;
                        });
                        

                        
                         Canvas.removeLocalLayer(exportLayerName);
                              Canvas.addLocalLayer(
                                exportLayerName,
                                newExportLayer,
                                "#5dff47",
                                "#5dff47",
                                true
                              );
                          
                              if (layerControls) {
                                 const dummy = L.layerGroup(); 
                                layerControls.addOverlay(
                                  dummy,
                                  exportLayerName,
                                  true,
                                  false,
                                  true,
                                  exportLayerName,
                                  false,
                                  false,
                                  true
                                );
                              }

                        map.flyToBounds(newLayer.getBounds());
                                  console.log("Exported Layer GeoJSON:", newExportLayer, 'with name:', exportLayerName);
                              console.log(`Exported ${cleanedFeatures.length} features to layer control.`);
                            } catch (err) {
                              console.error("Error exporting layer:", err);
                              toast.error("Failed to export layer. Check console for details.");
                            }
                          }}
                        >
                          Export Feature
                        </button>

                
                        <span
                          className="highlight-count"
                          onMouseDown={(e) => e.stopPropagation()}
                        >
                          Filtered:{" "}
                          {
                            // Count features where either shouldHighlightRow is true OR selected via `selection` property
                            layerData.features.filter(
                              (feature) =>
                                shouldHighlightRow(feature.properties) || feature.properties.selection
                            ).length
                          }
                        </span>
                        <span
                          className="highlight-count"
                          onMouseDown={(e) => e.stopPropagation()}
                        >
                          Total: {
                            // Count only features that are currently selectable / relevant (optional: can keep as all)
                            layerData.features.length
                          }
                        </span>


                    <input
                    type="text"
                    className="form-control"
                    placeholder="Search table..."
                    style={{ width: "200px", fontSize: "13px" }}
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value.toLowerCase())}
                  />

                  </div>

                  <div
                    className="attribute-table-container"
                    onMouseDown={(e) => e.stopPropagation()}
                  >
                    <div className="table-scroll">
                      <table className="table-striped">
                        <thead>
                          {/* <tr>
                            {Object.keys(layerData.features[0].properties).map(
                              (key, index) => (
                                <th key={index}>{key}</th>
                              )
                            )}
                          </tr> */}
                          <tr>
                            {layerData?.features?.[0]?.properties &&
                              Object.keys(layerData.features[0].properties).filter((key) => !["_parentLayer", "_layerColor"].includes(key)).map(
                                (key, index) => <th key={index}>{key}</th>
                              )}
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {/* {layerData.features.map((feature, rowIndex) => ( */}
                          {/* For filters row  */}
                          {layerData.features
                            .filter((feature) =>
                              Object.values(feature.properties).some((val) =>
                                String(val).toLowerCase().includes(searchText)
                              )
                            )
                            .map((feature, rowIndex) => (

                            <tr
                              key={rowIndex}
                              className={
                                feature.properties.selection ||
                                shouldHighlightRow(feature.properties)
                                  ? "highlight-row"
                                  : ""
                              }
                            >
                              {Object.keys(
                                layerData.features[0].properties
                              ).filter((key) => !["_parentLayer", "_layerColor"].includes(key)).map((key, colIndex) => (
                                // <td
                                //   key={colIndex}
                                //   contentEditable={isEditable}
                                //   suppressContentEditableWarning={true}
                                //   onBlur={(e) =>
                                //     handleEditChange(e, rowIndex, key)
                                //   }
                                // >
                                //   {typeof feature.properties[key] === "object"
                                //     ? JSON.stringify(feature.properties[key])
                                //     : feature.properties[key] || "null"}
                                // </td>
                                <td key={colIndex}>
                                  {key === "selection" ? (
                                    <input
                                      type="checkbox"
                                      checked={feature.properties.selection}
                                      onChange={() =>
                                        handleCheckboxToggle(rowIndex)
                                      }
                                    />
                                  ) : (
                                    <div
                                      contentEditable={isEditable}
                                      suppressContentEditableWarning={true}
                                      onBlur={(e) =>
                                        handleEditChange(e, rowIndex, key)
                                      }
                                    >
                                      {typeof feature.properties[key] ===
                                      "object"
                                        ? JSON.stringify(
                                            feature.properties[key]
                                          )
                                        : feature.properties[key] ?? "null"}
                                    </div>
                                  )}
                                </td>
                              ))}
                              <td>
                                <button
                                  onClick={() => handleDeleteRow(rowIndex)}
                                >
                                  Delete
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </>
              )}
            </div>
          </Rnd>
        </div>
      )}

      {showSelectPopup && (
        <div className="modal-overlay" style={{ zIndex: 1001 }}>
          <Rnd
            style={{
              width: "100%",
              height: "100%",
              left: tools ? "60px" : "400px",
              zIndex: 1001,
            }}
            default={{
              x:  tools ? 0 : 400,
              y: 0,
              width: 600,
              height: 250,
            }}
            minWidth={600}
            minHeight={250}
            maxWidth={900}
            maxHeight={400}
            disableDragging={false}
            bounds="window"
            enableResizing={{
              bottomRight: true,
              bottomLeft: true,
              topRight: true,
              topLeft: true,
              left: true,
              right: true,
              top: true,
              bottom: true,
            }}
          >
            <div className="modal-content">
              <div className="user-modal-header">
                <i
                  className="fa-solid fa-xmark cancel"
                  style={{ margin: "0px", marginBottom: "10px" }}
                  onClick={() => setShowSelectPopup(false)}
                ></i>
              </div>

              {layerData.features.length > 0 && (
                <AttributeQuery
                  columns={Object.keys(layerData.features[0].properties)}
                  values={layerData.features.map(
                    (feature) => feature.properties
                  )}
                  onQueryChange={setQueryConditions}
                  setShowSelectPopup={setShowSelectPopup}
                />
              )}
            </div>
          </Rnd>
        </div>
      )}

      {modalOpen && (
        <div className="modal-overlay">
          <Rnd
            default={{
              x: window.innerWidth / 4,
              y: window.innerHeight / 4,
              width: modalSize.width,
              height: modalSize.height,
            }}
            minWidth={300}
            minHeight={300}
            bounds="window"
            onResizeStop={(e, direction, ref) => {
              setModalSize({
                width: ref.offsetWidth,
                height: ref.offsetHeight,
              });
            }}
          >
            <div className="modal-content">
              <div className="user-modal-header">
                <i
                  className="fa-solid fa-xmark cancel"
                  style={{ marginBottom: "10px" }}
                  onClick={closeModal}
                ></i>
              </div>

              {/*  If modalImages exist, show image carousel */}
              {modalImages.length > 0 && (
                <div
                  id="imageCarousel"
                  className="carousel slide"
                  data-bs-ride="carousel"
                >
                  <div className="carousel-inner">
                 {modalImages.map((imgUrl, idx) => (
                  <div
                    key={idx}
                    className={`carousel-item ${idx === 0 ? "active" : ""}`}
                  >
                    {imgUrl.includes("drive.google.com") ? (
                      <iframe
                        src={`https://drive.google.com/file/d/${
                          imgUrl.split("/")[5]
                        }/preview`}
                        className="d-block w-100 modal-iframe"
                        title={`Drive Preview ${idx}`}
                        allowFullScreen
                      ></iframe>
                    ) : (
                      <img
                        src={imgUrl} 
                        alt={`image-${idx}`}
                        className="d-block w-100 slider-image"
                      />
                    )}
                  </div>
                ))}

                  </div>

                  {/* Carousel controls */}
                  <button
                    className="carousel-control-prev"
                    type="button"
                    data-bs-target="#imageCarousel"
                    data-bs-slide="prev"
                  >
                    <span className="carousel-control-prev-icon"></span>
                    <span className="visually-hidden">Previous</span>
                  </button>
                  <button
                    className="carousel-control-next"
                    type="button"
                    data-bs-target="#imageCarousel"
                    data-bs-slide="next"
                  >
                    <span className="carousel-control-next-icon"></span>
                    <span className="visually-hidden">Next</span>
                  </button>
                </div>
              )}

              {/*  If modalUrl exists, show iframe (CCTV, Map, etc.) */}
              {modalUrl && (
                <div className="d-block w-100 modal-iframe-wrapper">
                  <iframe
                    src={modalUrl}
                    className="d-block w-100 modal-iframe"
                    allowFullScreen
                    title="Embedded Content"
                  ></iframe>
                </div>
              )}
            </div>
          </Rnd>
        </div>
      )}

      {showSymbology && (
        <div className="modal-overlay" style={{ zIndex: 100 }}>
          <Rnd
            style={{
              width: "100%",
              height: "100%",
              zIndex: 100,
            }}
            default={{
              x: 0,
              y: 0,
              width: 600,
              height: 250,
            }}
            minWidth={600}
            minHeight={450}
            maxWidth={900}
            maxHeight={600}
            disableDragging={false}
            bounds="window"
            enableResizing={{
              bottomRight: true,
              bottomLeft: true,
              topRight: true,
              topLeft: true,
              left: true,
              right: true,
              top: true,
              bottom: true,
            }}
          >
            <div className="modal-content">
              <div className="user-modal-header">
                <i
                  className="fa-solid fa-xmark cancel"
                  style={{ marginBottom: "10px" }}
                  onClick={(e) => setShowSymbology(e.target.checked)}
                ></i>
              </div>
              <Symbology
                setLayerData={setLayerData}
                layerData={layerData}
                vectors={vectors}
              />
            </div>
          </Rnd>
        </div>
      )}

      {showFieldCalculator && (
        <div className="modal-overlay" style={{ zIndex: 1001 }}>
          <Rnd
          style={{
            width: "100%",
            height: "100%",
            left: tools ? "60px" : "400px",
            zIndex: 1001,
          }}
            // default={{
            //   x: window.innerWidth / 4,
            //   y: window.innerHeight / 4,
            //   width: modalSize.width,
            //   height: modalSize.height,
            // }} 
            default={{
              x: tools ? 0 : 400,
              y: 0,
              width: 650,
              height: 550,
            }}
            minWidth={300}
            minHeight={300}
            bounds="window"
            onResizeStop={(e, direction, ref) => {
              setModalSize({
                width: ref.offsetWidth,
                height: ref.offsetHeight,
              });
            }}
          >
            <div className="modal-content">
              <div className="user-modal-header">
                <i
                  className="fa-solid fa-xmark cancel"
                  style={{ marginBottom: "10px" }}
                  onClick={(e) => {
                    setShowFieldCalculator(false);
                    setManualQuery("");
                    setSelectedOperator("");
                  }}
                ></i>
              </div>

              <div className="modal-body">
          
                <label style={{ fontSize: "15px", fontWeight: "bold" }}>
                  Select column to assign result :{" "}
                </label>
                <select
                  className="form-select mt-2"
                  onChange={(e) => setTargetColumn(e.target.value)}
                >
                  <option value="">Select column to assign result</option>
                  {Object.keys(layerData.features[0].properties).filter((key) => !["selection", "_parentLayer", "_layerColor"].includes(key)).map(
                    (key, index) => (
                      <option key={index} value={key}>
                        {key}
                      </option>
                    )
                  )}
                </select>

                <br />
                <label style={{ fontSize: "15px", fontWeight: "bold" }}>
                  Select column to perform query :{" "}
                </label>
                <select
                  className="form-select"
                  onChange={(e) => {
                    const col = e.target.value;
                    if (!col) return;
                    setManualQuery((prev) => {
                      const words = prev.trim().split(/\s+/);
                      if (words.includes(col)) return prev; // prevent duplicates
                      return prev.trim() === "" ? col : `${prev.trim()} ${col}`;
                    });
                  }}
                >
                  <option selected disabled>
                    select column
                  </option>
                  {Object.keys(layerData.features[0].properties).filter((key) => !["selection", "_parentLayer", "_layerColor"].includes(key)).map(
                    (key, index) => (
                      <option key={index} value={key}>
                        {key}
                      </option>
                    )
                  )}
                </select>

                <br />
                <label style={{ fontSize: "15px", fontWeight: "bold" }}>
                  Select operator to perform query :{" "}
                </label>
                <select
                  className="form-select mt-2"
                  onChange={(e) => {
                    const op = e.target.value;
                    if (!op) return;

                    setManualQuery((prev) =>
                      prev.trim() === "" ? "" : `${prev.trim()} ${op}`
                    );
                    setSelectedOperator(""); 
                  }}
                  value={selectedOperator}
                >
                  <option value="" selected>Select Operator</option>
                  <option value="+">+</option>
                  <option value="-">-</option>
                  <option value="*">*</option>
                  <option value="/">/</option>
                </select>

                

                <br />
                <label style={{ fontSize: "15px", fontWeight: "bold" }}>
                  {" "}
                  Query :{" "}
                </label>
                <textarea
                  className="form-control mt-2"
                  rows="3"
                  value={manualQuery}
                  onChange={(e) => setManualQuery(e.target.value)}
                  style={{ fontSize: "14px", fontFamily: "monospace" }}
                />

                <button
                  className="btn btn-primary mt-2"
                  onClick={calculateField}
                >
                  Calculate
                </button>

                <button
                  className="btn btn-danger mt-2 ms-2"
                  onClick={() => {
                    setManualQuery("");
                    setSelectedOperator("");
                  }}
                >
                  Clear Query
                </button>
              </div>
            </div>
          </Rnd>
        </div>
      )}

      <ToastContainer position="bottom-right" draggable={false} />
    </>
  );
};

export default SelectByAttribute;
